import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LinkTemplate } from '../interfaces/link-template.interface';

@Injectable({
  providedIn: 'root'
})
export class LinkTemplateService {
  
  readonly url: string = 'LinkTemplate';

	constructor(private http: HttpClient) {}

  public getAllLinkTemplates(): Observable<LinkTemplate[]> {
		return this.http.get<LinkTemplate[]>(this.url + '/'+ 'GetAllLinkTemplates');
	}
}
